import React, { useState } from 'react';
import { Heart } from 'lucide-react';

const ProductCard15 = ({ product, onClick }) => {
    const [wishlisted, setWishlisted] = useState(false);
    const [hovered, setHovered] = useState(false);

    const handleWishlistToggle = (e) => {
        e.stopPropagation();
        setWishlisted((prev) => !prev);
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Nunito+Sans:wght@300;400;600&display=swap');
            `}</style>

            <div
                onClick={() => onClick && onClick(product)}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{
                    backgroundColor: '#FEFCE8',
                    borderRadius: '16px',
                    cursor: 'pointer',
                    transition: 'all 0.4s ease',
                    overflow: 'hidden',
                    boxShadow: hovered
                        ? '0 12px 32px rgba(30, 64, 175, 0.12)'
                        : '0 2px 8px rgba(30, 64, 175, 0.06)',
                    transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
                }}
            >
                {/* Image Container */}
                <div
                    style={{
                        position: 'relative',
                        aspectRatio: '3 / 4',
                        overflow: 'hidden',
                        borderRadius: '16px 16px 0 0',
                    }}
                >
                    <img
                        src={product.image}
                        alt={product.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transform: hovered ? 'scale(1.05)' : 'scale(1)',
                            transition: 'transform 0.5s ease',
                        }}
                    />

                    {/* Badge */}
                    {product.badge && (
                        <span
                            style={{
                                position: 'absolute',
                                top: '12px',
                                left: '12px',
                                backgroundColor: '#1E40AF',
                                color: '#FFFFFF',
                                fontFamily: "'Nunito Sans', sans-serif",
                                fontSize: '11px',
                                fontWeight: 600,
                                letterSpacing: '0.5px',
                                textTransform: 'uppercase',
                                padding: '4px 14px',
                                borderRadius: '9999px',
                            }}
                        >
                            {product.badge}
                        </span>
                    )}

                    {/* Wishlist Heart */}
                    <button
                        onClick={handleWishlistToggle}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            width: '36px',
                            height: '36px',
                            backgroundColor: 'rgba(254, 252, 232, 0.85)',
                            border: 'none',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            backdropFilter: 'blur(4px)',
                        }}
                    >
                        <Heart
                            size={18}
                            style={{
                                color: wishlisted ? '#1E40AF' : '#64748B',
                                fill: wishlisted ? '#1E40AF' : 'none',
                                transition: 'color 0.3s ease, fill 0.3s ease',
                            }}
                        />
                    </button>
                </div>

                {/* Product Info */}
                <div style={{ padding: '16px' }}>
                    <h3
                        style={{
                            fontFamily: "'Quicksand', sans-serif",
                            fontSize: '15px',
                            fontWeight: 600,
                            color: '#1E293B',
                            margin: '0 0 8px 0',
                            lineHeight: 1.4,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {product.name}
                    </h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                            style={{
                                fontFamily: "'Nunito Sans', sans-serif",
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#1E40AF',
                            }}
                        >
                            {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                        </span>
                        {product.originalPrice && (
                            <span
                                style={{
                                    fontFamily: "'Nunito Sans', sans-serif",
                                    fontSize: '13px',
                                    color: '#64748B',
                                    textDecoration: 'line-through',
                                }}
                            >
                                {typeof product.originalPrice === 'number'
                                    ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}`
                                    : product.originalPrice}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductCard15;
